export default "__VITE_ASSET__gBBIiiAO__"